import { RouteItem } from '@eastcoal/router/types/route'

import { PRICE_COMPARE_CREATE_PAGE_PATH } from './constants/path'

export const priceCompareCreateRoute: RouteItem = {
  title: '新增比价',
  hideInMenu: true,
  path: PRICE_COMPARE_CREATE_PAGE_PATH,
  Component: () => import('./index')
}
